import React from 'react';
import { SummaryTextFieldProps, classPrefix } from './types';
import { renderIf } from "app/services/reactUtils.service";
import { createStyles, makeStyles, TextField } from '@material-ui/core';

/**
 * Renders textfield in a read-only state
 */
export const SummaryTextField = (props: SummaryTextFieldProps) => {

  const classes = useStyles();
  return (
    <>
    {
      renderIf(!!props.value, () => (
        <div className={classes.root}>
          <TextField
            disabled={true}
            multiline={true}
            fullWidth={true}
            value={props.value}
            label={props.labelText}
          />
        </div>
      ))
    }
    </>
  )
}

/** Styles for textfield */
const useStyles = makeStyles(() =>
  createStyles({
    root: {

      [`& .${classPrefix}-MuiInputBase-root`]: {
        padding: '2px 0px'
      },

      [`& .${classPrefix}-MuiInputBase-input`]: {
        fontSize: '16px',
        lineHeight: '1.3',
        color: 'rgba(0, 0, 0, 0.54)'
      },

      [`& .${classPrefix}-MuiFormControl-root`]: {
        margin: '10px 0 0 0'
      },

      [`& .${classPrefix}-MuiFormLabel-root`]: {
        fontSize: '16px',
        color: '#101010'
      },

      [`& .${classPrefix}-MuiInputLabel-shrink`]: {
        transform: 'translate(0, 0)'
      },
      marginBottom: '5px'
    },
  }),
);
